import { render, staticRenderFns } from "./adminOweFeeDetailList.vue?vue&type=template&id=57268e96&scoped=true"
import script from "./adminOweFeeDetailList.vue?vue&type=script&lang=js"
export * from "./adminOweFeeDetailList.vue?vue&type=script&lang=js"
import style0 from "./adminOweFeeDetailList.vue?vue&type=style&index=0&id=57268e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57268e96",
  null
  
)

export default component.exports